<script setup>
import { ContextMode } from '@episerver/content-delivery'

defineProps(['model'])

const { resolvedContent } = useResolvedContent()
</script>

<template>
  <div
    v-for="(block, index) in model"
    :key="index"
    class="Grid-cell w-full"
    :data-epi-content-id="resolvedContent.mode === ContextMode.Edit ? block.contentLink.guidValue : null"
  >
    <GenericsBlock :model="block" />
  </div>
</template>
